/**
 * Removes specified query params from the current URL without reloading the page
 * @param paramsToRemove - List of query params names to remove from the URL
 */
export function removeQueryParams(paramsToRemove: string[]): void {
  if (!paramsToRemove || paramsToRemove.length === 0) return;

  const url = new URL(window.location.href);
  const initialSearchParams = url.search;

  paramsToRemove.forEach((param) => {
    url.searchParams.delete(param);
  });

  if (url.search !== initialSearchParams) {
    window.history.replaceState({}, document.title, url.toString());
  }
}
